import { FirebaseError } from 'firebase/app';
import { collection, getDocs, query, where } from 'firebase/firestore';

import { db } from '../../config';

export const fetchDocumentFromCollectionByFilter = async <T>(
  collectionPath: string,
  key: string,
  value: string,
): Promise<T | null> => {
  if (!value) {
    throw new FirebaseError('invalid-argument', 'No code provided');
  }

  const collectionRef = collection(db, collectionPath);
  const codeQuery = query(collectionRef, where(key as string, '==', value));

  const snapshot = await getDocs(codeQuery);

  if (snapshot.empty) {
    throw new FirebaseError('not-found', `No records found for the provided code: ${value}`);
  }

  const data = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  })) as unknown as T[];

  if (data.length > 1) {
    throw new FirebaseError('data-conflict', 'Duplicate records found for the provided code!');
  }

  return data[0];
};
